module.exports = __webpack_public_path__ + "static/media/3 Train-Lateral_Z2.7861e679.png";